import { createTheme } from '@mui/material/styles'

// Design tokens from Figma
export const tokens = {
  colors: {
    primary: {
      main: '#501BC0',
      light: '#7349CD',
      dark: '#3d1494',
      100: '#DCD1F2',
      200: '#B9A4E6',
      500: '#501BC0',
    },
    background: '#EDE6FF',
    gray: {
      900: '#141414',
      base6: '#1C1C1E',
      text: '#131313',
    },
    error: '#FF2633',
    success: '#501BC0',
    warning: '#FF9800',
  },
  typography: {
    fontFamily: {
      heading: 'Merriweather, serif',
      body: 'Poppins, sans-serif',
      input: 'Inter, sans-serif',
    },
  },
}

export const theme = createTheme({
  palette: {
    primary: {
      main: tokens.colors.primary.main,
      light: tokens.colors.primary.light,
      dark: tokens.colors.primary.dark,
    },
    background: {
      default: tokens.colors.background,
    },
    error: {
      main: tokens.colors.error,
    },
  },
  typography: {
    fontFamily: tokens.typography.fontFamily.body,
    h1: {
      fontFamily: tokens.typography.fontFamily.heading,
      fontWeight: 900,
      fontSize: 32,
      lineHeight: '43px',
      letterSpacing: '1px',
    },
    h2: {
      fontFamily: tokens.typography.fontFamily.body,
      fontWeight: 600,
      fontSize: 16,
      letterSpacing: '-0.32px',
    },
    body1: {
      fontFamily: tokens.typography.fontFamily.body,
      fontSize: 14,
      lineHeight: 1.4,
    },
    body2: {
      fontFamily: tokens.typography.fontFamily.body,
      fontSize: 12,
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 300,
          fontFamily: tokens.typography.fontFamily.body,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          backgroundColor: tokens.colors.background,
        },
      },
    },
  },
})
